import { createFromIconfontCN } from '@ant-design/icons'

const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2343817_3u2zkgen0ry.js',
    extraCommonProps: { className: 'iconfont' }
});

export default IconFont;
